import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=a4ecab44&scoped=true&"
import script from "./ResultDetail.vue?vue&type=script&lang=js&"
export * from "./ResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultDetail.vue?vue&type=style&index=0&id=a4ecab44&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ecab44",
  null
  
)

export default component.exports